((window, document) => {
    function disableForm(this: HTMLFormElement, ev: SubmitEvent) {
        if (ev.defaultPrevented) {
            return false;
        }

        this.classList.add('was-validated');

        // data-val fields have already been validated, aspnet-validation-bootstrap5.ts only lets the event through when valid
        if (this.checkValidity() === false) {
            ev.preventDefault();
            ev.stopPropagation();
            return false;
        }

        if (this.dataset.submitted) {
            ev.preventDefault();
            return false;
        }

        if (this.dataset.confirm && !confirm(this.dataset.confirm)) {
            ev.preventDefault();
            return false;
        }

        const btn = ev.submitter ?? document.createElement("button");

        const btnProps = {
            display: btn?.style.display,
            width: btn?.style.width,
            innerHTML: btn?.innerHTML
        }

        btn.style.display = 'inline-block';
        btn.style.width = btn.clientWidth + 'px';
        btn.innerHTML = "<i class='fas fa-fw fa-circle-notch fa-spin'></i>";
        btn.classList.add("disabled");
        this.dataset.submitted = "true";

        this._enable = () => {
            btn.style.display = btnProps.display;
            btn.style.width = btnProps.width;
            btn.innerHTML = btnProps.innerHTML;
            btn.classList.remove("disabled");
            delete this.dataset.submitted;
        }

        return true;
    }

    const forms = Array.from(document.getElementsByTagName("form"))
        .filter(form => form.dataset.disableOnSubmit != "off");

    forms.forEach(form => form.addEventListener('submit', disableForm));

    window.addEventListener('pageshow', () => forms.forEach(form => form._enable?.()));
})(window, document);